import { useState } from 'react';
import { Content } from '../types';
import { getContents } from '../api/contentApi';

export function useContents() {
  const [contents, setContents] = useState<Content[]>([]);

  const fetchContents = async (q?: string, categoryId?: number | null, topicAreaId?: number | null, tag?: string | null) => {
    const data = await getContents(q, categoryId, topicAreaId, tag);
    setContents(data);
  };

  return { contents, fetchContents };
} 